export const PROJECT_NAME_INPUT_TIMEOUT = 200;
export const VALIDATION_FAILED_MESSAGE = 'Validation failed: \r\n -- :';
export const SEVERITY_ERROR_MESSAGE = 'Severity: Error';
